import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex'
  },

  iconRoot: {
    alignSelf: 'center',
    height: '100%'
  },

  icon: {
    marginTop: '0.125rem',
    fontSize: theme.size.base,
    color: theme.palette.primary.main,
    cursor: 'pointer'
  }
}))

export default useStyles
